// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import NpcChatController from "./npc_chat_controller"
application.register("npc-chat", NpcChatController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ReferencesController from "./references_controller"
application.register("references", ReferencesController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import FormController from "./form_controller"
application.register("form", FormController)

import SpotlightController from "./spotlight_controller"
application.register("spotlight", SpotlightController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import FocusModeController from "./focus_mode_controller"
application.register("focus-mode", FocusModeController)

import PlaySurfaceController from "./play_surface_controller"
application.register("play-surface", PlaySurfaceController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import GameElementFormController from "./game_element_form_controller"
application.register("game-element-form", GameElementFormController)

import ArticleFormController from "./article_form_controller"
application.register("article-form", ArticleFormController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import InventoryFormController from "./inventory_form_controller"
application.register("inventory-form", InventoryFormController)

import InventoryFilterController from "./inventory_filter_controller"
application.register("inventory-filter", InventoryFilterController)

import ArticleSelectController from "./article_select_controller"
application.register("article-select", ArticleSelectController)

import ReadAlongController from "./read_along_controller"
application.register("read-along", ReadAlongController)

import CalendarFormController from "./calendar_form_controller"
application.register("calendar-form", CalendarFormController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import StageController from "./stage_controller"
application.register("stage", StageController)

import TvHudController from "./tv_hud_controller"
application.register("tv-hud", TvHudController)

import EncounterController from "./encounter_controller"
application.register("encounter", EncounterController)

import TavernDialogueController from "./tavern_dialogue_controller"
application.register("tavern-dialogue", TavernDialogueController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MonsterSearchController from "./monster_search_controller"
application.register("monster-search", MonsterSearchController)

import SessionTimerController from "./session_timer_controller"
application.register("session-timer", SessionTimerController)

import ArticleLinkHovercardController from "./article_link_hovercard_controller"
application.register("article-link-hovercard", ArticleLinkHovercardController)

// trix-exts-controllers for titles, underline, mark, hr, inline_code, table
import TrixExtsTitlesController from "./trix-exts/trix-exts-titles-controller"
application.register("trix-exts-titles", TrixExtsTitlesController)

import TrixExtsUnderlineController from "./trix-exts/trix-exts-underline-controller"
application.register("trix-exts-underline", TrixExtsUnderlineController)

import TrixExtsMarkController from "./trix-exts/trix-exts-mark-controller"
application.register("trix-exts-mark", TrixExtsMarkController)

import TrixExtsHrController from "./trix-exts/trix-exts-hr-controller"
application.register("trix-exts-hr", TrixExtsHrController)

import TrixExtsInlineCodeController from "./trix-exts/trix-exts-inline-code-controller"
application.register("trix-exts-inline-code", TrixExtsInlineCodeController)

import TrixExtsTableController from "./trix-exts/trix-exts-table-controller"
application.register("trix-exts-table", TrixExtsTableController)

import TrixExtsTableTableEditorController from "./trix-exts/table/table-editor-controller"
application.register("table-editor", TrixExtsTableTableEditorController)

import DdbSyncController from "./ddb_sync_controller"
application.register("ddb-sync", DdbSyncController)

import StageFormController from "./stage_form_controller"
application.register("stage-form", StageFormController)

import StageAssetComposerController from "./stage_asset_composer_controller"
application.register("stage-asset-composer", StageAssetComposerController)

import StageViewportController from "./stage_viewport_controller"
application.register("stage-viewport", StageViewportController)

import AdventureGraphController from "./adventure_graph_controller"
application.register("adventure-graph", AdventureGraphController)

import DmNotesRevealController from "./dm_notes_reveal_controller"
application.register("dm-notes-reveal", DmNotesRevealController)

import SpotifyPlayerController from "./spotify_player_controller"
application.register("spotify-player", SpotifyPlayerController)

import SpotifyHudController from "./spotify_hud_controller"
application.register("spotify-hud", SpotifyHudController)

import FeedFilterController from "./feed_filter_controller"
application.register("feed-filter", FeedFilterController)
